import React from 'react';
import { useContent } from '../content/ContentContext';
import { Reveal, SectionHeader } from '../lib/ui';

const Approach: React.FC = () => {
  const { approach } = useContent();
  if (!approach.visible) return null;

  return (
    <section id="arbeitsweise" className="scroll-mt-20 border-t border-line py-24 md:py-32">
      <div className="container-site">
        <SectionHeader eyebrow={approach.eyebrow} title={approach.title} intro={approach.intro} align="center" />
        <div className="mx-auto mt-14 grid max-w-5xl gap-6 md:mt-20 md:grid-cols-3">
          {approach.steps.map((step, i) => (
            <Reveal key={step.title} delay={i * 0.08}>
              <div className="relative h-full rounded-3xl border border-line bg-surface p-7 sm:p-8">
                <div className="flex h-9 w-9 items-center justify-center rounded-full border border-accent/30 bg-accent/10 text-sm font-semibold text-accent">{i + 1}</div>
                <h3 className="mt-5 text-xl font-semibold tracking-tight">{step.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-fg-2">{step.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Approach;
